import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=b59a51c4&scoped=true&"
import script from "./StatusCard.vue?vue&type=script&lang=ts&"
export * from "./StatusCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=b59a51c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59a51c4",
  null
  
)

export default component.exports